import script from "./duplicate-requisition-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./duplicate-requisition-modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__